import { useEffect, useState } from "react";
import "./bulk-upload.scss";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ImportDataPopup from "@pages/Vendors/Popups/index";
import {
  getTemplates,
  uploadVendors,
  uploadVendorsHeadcount,
  uploadVendorsLocation,
  uploadVendorsUsers,
} from "@services/vendors.service";
import { toast } from "react-toastify";
import { getValue } from "@utils/lodash";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { downloadURL } from "@services/auth.service";
import { getEncodedKey } from "@_common/text-helpers";
import { saveAs } from "file-saver";
import { handleDownloadOnClick } from "@_common/downloadfile";

export default function BulkUpload(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isBulkUploadPopupVisible, setBulkuploadPopupVisibility] = useState(
    false
  );
  const [isDataImported, setIsDataImported] = useState(false);
  const [response, setResponse] = useState({});
  const [importType, setImportType] = useState("");
  const [importedFile, setImportTedFile] = useState<any>(null);

  const [vendorURL, setVendorURL] = useState("");
  const [vendorUserURL, setVendorUserURL] = useState("");
  const [mapVendorLocationURL, setMapVendorLocationURL] = useState("");
  const [vendorHeadcountURL, setVendorHeadcountURL] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    getData();
  }, []);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    let payload: any = {};
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getTemplates(queryRequest);
      if (resp) {
        let down1 = getValue(resp, `data`, []).filter(
          (item: object) => getValue(item, `type`, "") === "VENDOR"
        );
        let down2 = getValue(resp, `data`, []).filter(
          (item: object) => getValue(item, `type`, "") === "VENDOR_USER"
        );
        let down3 = getValue(resp, `data`, []).filter(
          (item: object) => getValue(item, `type`, "") === "MAP_VENDOR_LOCATION"
        );
        let down4 = getValue(resp, `data`, []).filter(
          (item: object) => getValue(item, `type`, "") === "VENDOR_HEADCOUNT"
        );
        setVendorURL(
          getValue(down1, `length`, 0) > 0
            ? getValue(down1, `[${0}].url`, "")
            : ""
        );
        setVendorUserURL(
          getValue(down2, `length`, 0) > 0
            ? getValue(down2, `[${0}].url`, "")
            : ""
        );
        setMapVendorLocationURL(
          getValue(down3, `length`, 0) > 0
            ? getValue(down3, `[${0}].url`, "")
            : ""
        );
        setVendorHeadcountURL(
          getValue(down4, `length`, 0) > 0
            ? getValue(down4, `[${0}].url`, "")
            : ""
        );
      }
    } catch (error) {}
  };
  const handleUpload = async () => {
    let access_token = localStorage.getItem("accessToken");
    let port = window.location.origin.split("//")[1].split(":")[0];
    let getOriginString = port.split(".");
    const str = window.location.origin;
    const urls = str.split("://")[1];
    let domain = urls.split(".")[0];
    const source = urls.replace("vendor.", "");

    let mainSource =
      domain === "accenture"
        ? "client.dev.ascentcompliance.in"
        : getOriginString[0] === "localhost"
        ? "client.dev.ascentcompliance.in"
        : source;
    if (importType === "vendors") {
      try {
        let formData = new FormData();
        formData.append("file", importedFile);
        setSubmitLoading(true);
        let resp = await uploadVendors(formData, mainSource);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setImportType("");
          setImportTedFile(null);
          importedSuccessfully();
          setResponse(getValue(resp, `data`, {}));
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
    if (importType === "users") {
      try {
        let formData = new FormData();
        formData.append("file", importedFile);
        setSubmitLoading(true);
        let resp = await uploadVendorsUsers(formData, mainSource);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setImportType("");
          setImportTedFile(null);
          importedSuccessfully();
          setResponse(getValue(resp, `data`, {}));
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
    if (importType === "map-location") {
      try {
        let formData = new FormData();
        formData.append("file", importedFile);
        setSubmitLoading(true);
        let resp = await uploadVendorsLocation(formData, mainSource);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setImportType("");
          setImportTedFile(null);
          importedSuccessfully();
          setResponse(getValue(resp, `data`, {}));
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
    if (importType === "headcount") {
      try {
        let formData = new FormData();
        formData.append("file", importedFile);
        setSubmitLoading(true);
        let resp = await uploadVendorsHeadcount(formData, mainSource);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setImportType("");
          setImportTedFile(null);
          importedSuccessfully();
          setResponse(getValue(resp, `data`, {}));
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleImportPopup = (value: string) => {
    setBulkuploadPopupVisibility(true);
    setImportType(value);
  };
  const handleChangeUpload = async (e: any) => {
    // setImportTedFile(e.target.files[0]);
    setImportTedFile(e[0]);
  };
  const closePopup = () => {
    setBulkuploadPopupVisibility(false);
    setIsDataImported(false);
    setImportTedFile("");
  };
  const importedSuccessfully = () => {
    setIsDataImported(!isDataImported);
  };
  const handleDownload = async () => {
    if (importType === "vendors") {
      // var link = document.createElement("a");
      // link.target = "_blank";
      // link.download = "Contact";
      // link.href = vendorURL;
      // link.click();
      // let resp = await downloadURL(getEncodedKey(vendorURL));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(vendorURL,'Contact')
    }
    if (importType === "users") {
      //   var link = document.createElement("a");
      //   link.target = "_blank";
      //   link.download = "Contact";
      //   link.href = vendorUserURL;
      //   link.click();
      // let resp = await downloadURL(getEncodedKey(vendorUserURL));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(vendorUserURL,'Contact')

    }
    if (importType === "map-location") {
      //   var link = document.createElement("a");
      //   link.target = "_blank";
      //   link.download = "Contact";
      //   link.href = mapVendorLocationURL;
      //   link.click();
      // let resp = await downloadURL(getEncodedKey(mapVendorLocationURL));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(mapVendorLocationURL,'Contact')

    }
    if (importType === "headcount") {
      //   var link = document.createElement("a");
      //   link.target = "_blank";
      //   link.download = "Contact";
      //   link.href = vendorHeadcountURL;
      //   link.click();
      // let resp = await downloadURL(getEncodedKey(vendorHeadcountURL));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(vendorHeadcountURL,'Contact')

    }
  };

  return (
    <>
    <div className="icon-dropdown-holder">
      <UncontrolledDropdown>
        <DropdownToggle>
          <div className="add-filter-wrapper__filter-container">
            <div className="cursor-pointer">
              <img
                src="/images/file-upload.svg"
                className="img-fluid add-filter-wrapper__upload-image"
              />
              <p className="add-filter-wrapper__filter-title">BULK UPLOAD</p>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              handleImportPopup("vendors");
            }}
          >
            Add Vendors
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              handleImportPopup("users");
            }}
          >
            Add Users
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              handleImportPopup("map-location");
            }}
          >
            Map Location
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              handleImportPopup("headcount");
            }}
          >
            Add Head Count
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      </div>
      {isBulkUploadPopupVisible && (
        <ImportDataPopup
          handleUpload={handleUpload}
          handleChangeUpload={handleChangeUpload}
          closePopup={closePopup}
          isDataImported={isDataImported}
          setIsDataImported={setIsDataImported}
          importedSuccessfully={importedSuccessfully}
          importedFile={importedFile}
          setImportTedFile={setImportTedFile}
          response={response}
          handleDownload={handleDownload}
          submitLoading={submitLoading}
        />
      )}
    </>
  );
}
